import { sortBy } from 'lodash';
import { eventMomentFactory } from '../../../misc/eventMomentFactory';

/**
 * Returns the next best date from a list of dates,
 * relative to the current date and time zone.
 *
 * If there are dates in the future, it returns the first one.
 * Otherwise, it returns the closest date from today.
 *
 * @param {object} event Event object
 * @param {array} dates Array of dates to pick from
 * @returns {moment} The next best date
 */
export function getNextBestDate(event, dates) {
    const today = eventMomentFactory(event).startOf('day'),
        // first date in the future
        firstFutureDate = sortBy(
            dates.filter((d) => d.isSameOrAfter(today)),
            (d) => d.valueOf()
        )[0],
        // or closest date from today
        closestDate = sortBy(dates, (d) => Math.abs(d.diff(today)))[0];

    return firstFutureDate ?? closestDate;
}
